/** Dev Stripe test exempt product — keep in sync with smartsaas-backend/utils/exemptProductIds.mjs */
export const DEV_EXEMPT_PRODUCT_ID = 'prod_S6pAMmrip3qBwm';

const KNOWN_EXEMPT_PRODUCT_IDS = new Set([
	DEV_EXEMPT_PRODUCT_ID,
	'prod_S6pG674bnXT1xO',
]);

export function isKnownExemptStripeProductId(productId: unknown): boolean {
	if (typeof productId !== 'string' || productId.trim() === '') return false;
	if (productId.toLowerCase().includes('exempt')) return true;
	return KNOWN_EXEMPT_PRODUCT_IDS.has(productId);
}

export function isInternalProductName(productName: unknown): boolean {
	if (typeof productName !== 'string' || productName.trim() === '') return false;
	const lower = productName.trim().toLowerCase();
	return productName.trim() === 'INTERNAL_PLAN' || lower === 'internal' || lower === 'internal plan';
}

export function isExemptProductName(productName: unknown): boolean {
	if (typeof productName !== 'string' || productName.trim() === '') return false;
	const lower = productName.trim().toLowerCase();
	return productName === 'EXEMPT_PRODUCT' || lower.includes('exempt');
}
